module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-318-retro.2db590ea.jpg";